import React from "react";
import config from './../../config.js';
import Loading from './../../../components/loading.js';
import {
  uniqid,
  getsuffix
} from './../../../utils/utils.js';

import Notification from 'rc-notification';
let notification = null;
Notification.newInstance({
  style: {
    top: '45px',
    right: 0
  }
}, (n) => notification = n);

export default class UploadSubject extends React.Component {
  constructor(props) {
    super(props);
    //console.log(props);
    let user = {};

    if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
      user = JSON.parse(localStorage.user);
    }

    //console.log(current_project)

    const {
      projectid,
      groupid,
      subjectid
    } = props.match.params;

    this.state = {
      projectid: projectid || 0,
      groupid: groupid || 0,
      data_type: '',
      user: user,
      project: '',
      creator: '',
      page_title: subjectid == 0 ? '创建受试者' : '添加数据',
      page_subtitle: ' Create Subject',
      loading: false,
      subject: {
        id: subjectid || 0,
        description: '',
        uid: '',
        subject_name: ''
      },
      keys: [],
      multiple: true,
      files: [],
      filenames: [],
      filebytes: 0,
      filebtout: '',
      oss: {}
    }

    document.title = this.state.page_title + this.state.page_subtitle;
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputFileChange = this.handleInputFileChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    //console.log(uniqid());
  }


  componentDidMount() {
    if (this.state.projectid > 0) this.getProject();
  }


  getProject() {
    const me = this;

    let {
      projectid,
      user
    } = me.state;

    const postdata = {
      userid: user.id,
      companyid: user.company_id,
      projectid: projectid || 0,
      Authorization: localStorage.token,
      request: 'project'
    };

    fetch(config.host + '/project/index', {
      method: 'post',
      body: JSON.stringify(postdata)
    })
      .then(res => res.json())
      .then(json => {
        //console.log(json);
        if (json.status === 1) {
          const data = json.data;
          me.setState({
            project: data.project,
            creator: data.creator
          });
        } else {
          me.notify(json.message);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }


  removePreview(item) {
    let files = this.state.files;
    let count = this.state.multiple ? files.length : 1;
    let filebytes = this.state.filebytes;
    let newfiles = files.filter(f => f.thumb !== item.thumb);
    if (!newfiles.length) {
      this.setState({
        filebytes: 0,
        filebtout: ''
      })
    } else {
      filebytes -= item.size;
      this.approx(filebytes);
    }
    this.setState({
      files: newfiles,
      filebytes: filebytes
    });
  }


  notify(message) {
    notification.notice({
      content: <span>{message}</span>,
      duration: 4,
      style: {
        'bottom': 0,
        'right': 0
      }
    });
  }


  handleInputFileChange(event) { //获取文件变化
    event.preventDefault()
    let target = event.target
    let files = target.files
    let count = this.state.multiple ? files.length : 1;
    let filebytes = this.state.filebytes;
    if (count > 1) {
      this.setState({
        loading: false
      });
      this.notify('只能上传一个文件');
      return;
    }
    if (!files.length) return;
    for (let i = 0; i < count; i++) {
      files[i].thumb = URL.createObjectURL(files[i]);
      files[i].uploadprogress = '';
      filebytes += files[i].size;
    }
    // 转换为真正的数组
    files = Array.prototype.slice.call(files, 0);
    this.approx(filebytes);
    this.setState({
      filebytes: filebytes,
      files: this.state.files.concat(files)
    });
  }


  approx(bytevalue) { //计算文件单位和大小
    let filebtout = this.state.filebtout;
    for (let units = ["KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], n = 0, Approx = bytevalue / 1024; Approx > 1; Approx /= 1024, n++) {
      filebtout = Approx.toFixed(3) + " " + units[n];
    }
    this.setState({
      filebtout: filebtout
    });
  }

  handleInputChange(event) {
    const target = event.target;
    //const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    const value = target.value;
    const subject = this.state.subject;
    Object.assign(subject, {
      [name]: value
    });
    this.setState(subject);
  }

  handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    const me = this;
    me.setState({
      loading: true
    });
    if (me.state.files.length) {
      me.uploadfile();
    } else {
      me.setState({
        loading: false
      });
      me.notify('没有上传文件');
    }
  }

  postTimeline() {
    const me = this;
    const {
      user,
      projectid,
      groupid,
      data_type,
      subject,
      keys,
      filebytes,
      filenames,
      oss
    } = me.state;

    let postdata = Object.assign({}, {
      userid: me.state.project.user_id || user.id,
      companyid: me.state.creator.company_id || user.company_id,
      projectid: projectid,
      groupid: groupid,
      keys: keys,
      filenames: filenames,
      post_type: 'insert',
      filesize: filebytes,
      data_type: data_type, //use for 'archive' or image data
      Authorization: localStorage.token,
      bucket: oss.bucket
    }, subject);

    //console.log(postdata);

    fetch(config.host + '/project_subject/index', {
      method: 'post',
      body: JSON.stringify(postdata)
    })
      .then(response => {
        //console.log(response);
        return response.json()
      })
      .then(json => {
        if (json.status === 1) {
          me.notify('上传成功');
          setTimeout(function () {
            me.goBack();
          }, 1000);
        } else {
          me.setState({
            loading: false
          });
          me.notify(json.message);

        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  goBack() {
    this.props.history.goBack(1);
  }


  uploadfile() { //get oss config
    const me = this;
    let files = me.state.files;
    let count = me.state.multiple ? files.length : 1;
    const postdata = {
      userid: me.state.user.id,
      Authorization: localStorage.token
    };
    for (let i = 0; i < count; i++) {
      if (files[i].uploadprogress === '100%') continue;
      fetch(config.host + '/oss/index', {
        method: 'post',
        body: JSON.stringify(postdata)
      })
        .then(response => response.json())
        .then(json => {
          //console.log(json);
          me.setState({
            oss: json
          });
          me.xhrupload(json, files[i]);
        })
        .catch(error => {
          console.log(error);
        });
    }
  }


  xhrupload(json, file) {
    const me = this;
    const {
      files,
      keys,
      filenames,
      data_type
    } = me.state;
    //const files = me.state.files;
    //const keys = me.state.keys;
    let folder = data_type === 'archive' ? 'ProcessNew/others/' : 'ProcessNew/dicom/';
    const filename = uniqid() + getsuffix(file.name);
    const key = json.dir + folder + filename;
    let formData = new FormData();
    formData.append('success_action_status', '200');
    formData.append('OSSAccessKeyId', json.accessid);
    formData.append('policy', json.policy);
    formData.append('Signature', json.signature);
    formData.append('key', key);
    formData.append('file', file, file.name);

    let xhr = new XMLHttpRequest();
    xhr.open('POST', json.host, true);
    xhr.upload.onprogress = function (e) {
      if (e.lengthComputable) {
        const percentComplete = (e.loaded / e.total) * 100;
        //console.log(parseInt(percentComplete) + '% uploaded');

        file.uploadprogress = parseInt(percentComplete) + '%';
        Object.assign(files, file);
        me.setState(files);
      }
    };

    xhr.onreadystatechange = function () { //Call a function when the state changes.
      if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
        // 请求结束后,在此处写处理代码
        filenames.push(filename);
        keys.push(json.dir + folder);
        me.setState({
          keys: keys,
          filenames: filenames
        });
        //console.log(keys);
        if (keys.length === files.length) {
          //console.log('all file upload done');
          me.postTimeline();
        }
      }
    }
    xhr.onload = function (e) {
      //console.log('Server got:', e);
    };

    xhr.send(formData);
  }



  render() {
    const {
      user
    } = this.state;
    return (
      <div>
        <Loading display={this.state.loading} classtype="" />
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item ">
              <a className="text-dark " onClick={() => this.goBack()}><strong><i className="fa fa-chevron-left"></i> 返回 </strong></a>
              <small className="text-muted"> </small>
            </li>
            <li className="breadcrumb-item " aria-current="page">{this.state.page_title}</li>
          </ol>
        </nav>
        <div className="p-5 m-3 bg-white border rounded">
          <h5>上传{this.state.data_type === 'archive' ? '其它' : '影像'}数据</h5>
          <form onSubmit={this.handleSubmit}>

            <div className="form-group m-0 mt-3">
              <label>数据类型：</label>
              <label className="control-label mr-3">
                <input type="radio" name="data_type" className="control-input" checked={this.state.data_type === ''} value="" onChange={this.handleInputChange} />
                影像数据 </label>

              <label className="control-label" >
                <input type="radio" name="data_type" className="control-input" checked={this.state.data_type === 'archive'} value="archive" onChange={this.handleInputChange} />
                其它数据 </label>

            </div>
            {
              this.state.subject.id == 0 &&
              <div className="row mt-3 pt-3">
                <div className="col">
                  <div className="form-group">
                    <label>名称</label>
                    <input type="text" name="subject_name" className="form-control" placeholder="受试者名称或编号" value={this.state.subject.subject_name} onChange={this.handleInputChange} />
                  </div>
                </div>
                {user.company_id == 5 &&
                  <div className="col">
                    <div className="form-group">
                      <label>第三方平台(UID)</label>
                      <input type="text" name="uid" className="form-control" placeholder="受试者第三方uid" value={this.state.subject.uid} onChange={this.handleInputChange} />
                    </div>
                  </div>
                }

                <div className="col">
                  <div className="form-group">
                    <label>说明</label>
                    <input type="text" name="description" className="form-control" placeholder="诊断说明" value={this.state.subject.description} onChange={this.handleInputChange} />
                  </div>
                </div>
              </div>

            }

            <div className=" mt-3 pt-3">
              <div className="mb-2"><input type="file" className="btn btn-success" multiple accept='.encrypted' onChange={this.handleInputFileChange} /></div>
              <label>选择.encrypted文件 <span className="text-muted">(使用加密工具)</span> <a href={config.download_encrypted}><i className="fa fa-lock"></i> 下载安装加密工具</a> </label>
            </div>

            <div className="input-group">{this.state.filebtout}</div>

            <div className="row mt-3">
              {
                this.state.files.map((item, index) => {
                  return (
                    <div className="col-md-3 mb-3  imagepreview" key={index} >
                      <p className="rounded p-1 shadow" >{item.name}</p>
                      <a className="close shadow-lg  rounded text-dark text-right " aria-label="Close" onClick={this.removePreview.bind(this, item)}>
                        <span aria-hidden="true">&times;</span>
                      </a>
                      <small className="text-muted">{item.uploadprogress}</small>
                    </div>
                  );
                })
              }
            </div>

            <button type="submit" className="btn btn-primary mt-3" title="Submit">开始上传</button>

          </form>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/apps/console/uncategorized/upload_subject.js